import { addDays } from './dateRules'

/** Builds a Monday-start week grid for a month. Cells outside the month are null. */
export function buildMonthWeeks(year: number, month0: number): (Date | null)[][] {
  const first = new Date(year, month0, 1)
  const startOffset = (first.getDay() + 6) % 7 // days since Monday
  const start = addDays(first, -startOffset)

  const last = new Date(year, month0 + 1, 0)
  const endOffset = (7 - ((last.getDay() + 6) % 7) - 1) % 7
  const end = addDays(last, endOffset)

  const weeks: (Date | null)[][] = []
  let cur = new Date(start)
  while (cur <= end) {
    const week: (Date | null)[] = []
    for (let i = 0; i < 7; i++) {
      week.push(cur.getMonth() === month0 ? new Date(cur) : null)
      cur = addDays(cur, 1)
    }
    weeks.push(week)
  }
  return weeks
}
